import { useContext } from 'react';
import { AppContext } from '../../context/appContext';

/**
 * hook to get globalization data from initial nav data
 * @returns {array} globalization data
 */
const useGlobalization = () => {
  const [data] = useContext(AppContext);
  return data?.globalization || [];
};

export default useGlobalization;
